import React, { useState } from "react";
import "./sidebar.css";
import { Link } from "react-router-dom";
import Dashboard from "../../image/dashboard.svg";
import Jobcard from "../../image/jobcard.svg";
import Master from "../../image/master.svg";
import Timeline from "../../image/timeline.svg";
import Dataing from "../../image/dataiing.svg";

function Sidebar() {

  const [jobcard, setJobcard] = useState("disable");
  const [timeline, setTimeline] = useState("disable");

  return (
    <div>
      <p className="airpmo">airpmo</p>

      <ul className="menu">
        <li>
          <Link to="/">
            <img src={Dashboard} alt="" className="menuitemicon" />
            <span className="menuitem">Dashboard</span>
          </Link>
        </li>
        <li className={jobcard} >
          <Link to="/jobcard"
          onClick={() => {
            setJobcard(jobcard === 'off' ? 'active' : 'off');
          }}
          >
            <img src={Jobcard} alt="" className="menuitemicon" />
            <span className="menuitem">Job Card</span>
          </Link>
        </li>
        <li>
          <Link to="/master">
          <img src={Master} alt="" className="menuitemicon" />
            <span className="menuitem">Master</span>
          </Link>
        </li>
        <li className={timeline}>
          <Link to="/timeline" 
          onClick={() => {
            setTimeline(timeline === 'off' ? 'active' : 'off');
          }}
          >
            <img src={Timeline} alt="" className="menuitemicon" />
            <span className="menuitem">Timeline</span>
          </Link>
        </li>
        <li>
          <Link to="/data-ingestion">
          <img src={Dataing} alt="" className="menuitemicon" />
            <span className="menuitem">Data Ingestion</span>
          </Link>
        </li>
        <li>
          <Link to="/qa-qc">
            <span className="menuitem">QA/Qc</span>
          </Link>
        </li>
        <br />
        <li>
          <Link to="/usermanagement">
            <span className="menuitem">User Management</span>
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
